var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"message-card",attrs:{"dense":"","dark":""}},[_c('v-card-text',{staticClass:"subtitle",staticStyle:{"color":"black"}},[_vm._v(" "+_vm._s(_vm.myMessage)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }